import { c as _c } from "react/compiler-runtime";
import { useGSAP } from '@gsap/react';
import gsap from 'gsap';
import { RefObject } from 'react';
import { SplitText } from '@/lib/gsap';
interface LinkAnimationProps {
  wrapperRef: RefObject<HTMLDivElement | null>;
  titleSelector: string;
  allCasesTitle: string;
}
export const useGridTitleAnimation = t0 => {
  const $ = _c(8);
  const {
    wrapperRef,
    titleSelector,
    allCasesTitle
  } = t0;
  let t1;
  if ($[0] !== titleSelector || $[1] !== wrapperRef) {
    t1 = () => {
      if (!wrapperRef.current) {
        return;
      }
      const titleText = wrapperRef.current.querySelector(titleSelector);
      if (!titleText) {
        return;
      }
      const split = new SplitText(titleText, {
        type: "lines",
        linesClass: "line",
        mask: "lines"
      });
      const matchMedia = gsap.matchMedia();
      matchMedia.add({
        isDesktop: "(min-width: 992px)",
        isMobile: "(max-width: 991px)"
      }, context => {
        const {
          isMobile
        } = context.conditions as gsap.Conditions;
        if (isMobile) {
          return;
        }
        if (!split?.lines || split.lines.length === 0) {
          return;
        }
        gsap.set(split.lines, {
          yPercent: 100,
          opacity: 0
        });
        gsap.to(split.lines, {
          yPercent: 0,
          opacity: 1,
          duration: 0.6,
          ease: "power2.out",
          stagger: {
            each: 0.06,
            from: "start"
          },
          scrollTrigger: {
            trigger: titleText,
            start: "top bottom",
            end: "bottom 90%",
            toggleActions: "play none none reverse"
          }
        });
      });
    };
    $[0] = titleSelector;
    $[1] = wrapperRef;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== allCasesTitle) {
    t2 = [allCasesTitle];
    $[3] = allCasesTitle;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t2 || $[6] !== wrapperRef) {
    t3 = {
      dependencies: t2,
      scope: wrapperRef
    };
    $[5] = t2;
    $[6] = wrapperRef;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  useGSAP(t1, t3);
};